import React from 'react';
import { Page } from 'components/layout/panel/Page/Page';
import { useTranslator } from 'components/shared/hooks';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { Paper } from 'components/shared/surfaces/Paper/Paper';
import { PasswordSecurityContainer } from 'components/officials/PasswordSecurity/PasswordSecurityContainer';
import { ROUTE_OFFICIALS_LIST } from 'config/routes';

export const PasswordSecurityView: React.FC = () => {
  const trans = useTranslator();

  return (
    <React.Fragment>
      <Breadcrumb label={trans('BREADCRUMB.OFFICIALS.LIST')} to={ROUTE_OFFICIALS_LIST} />
      <Breadcrumb label={trans('BREADCRUMB.OFFICIALS.PASSWORD_SECURITY')} static />
      <Page title={trans('OFFICIALS.PASSWORD_SECURITY.TITLE')}>
        <Paper innerSpacing={2} outerSpacing={[0, 2, 2]}>
          <PasswordSecurityContainer />
        </Paper>
      </Page>
    </React.Fragment>
  );
};
